/* eslint-disable import/prefer-default-export */

export const EVENT_PERMALINK_UPDATED = 'EVENT_PERMALINK_UPDATED';
export const EVENT_UPDATED = 'EVENT_UPDATED';
